import React, { useEffect, useState } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";

const MenuProps = {
  PaperProps: {
    style: {
      height: "30vh",
      width: 300,
      overflowX: "hidden",
    },
  },
};

// Helper: always returns an array
const toArray = (val) => {
  if (Array.isArray(val)) return val;
  if (typeof val === "string" && val !== "") return val.split(",");
  return [];
};

export default function Dropdown({
  name,
  setFilterData,
  data,
  valueField,
  initialValue,
}) {
  const [selectOption, setSelectionOption] = useState(toArray(initialValue));

  useEffect(() => {
    setSelectionOption(toArray(initialValue));
  }, [initialValue]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    const newValue = typeof value === "string" ? value.split(",") : value;
    setSelectionOption(newValue);

    let result = "";
    if (name === "Company") result = "company";
    else if (name === "Category/Role") result = "category";
    else if (name === "Job Type") result = "jobType";
    else if (name === "Job Posted on") result = "jobPostedOn";

    setFilterData((prev) => ({ ...prev, [result]: newValue }));
  };

  const renderSelectedValue = (selected) => {
    if (!Array.isArray(selected) || selected.length === 0) return "";

    if (name !== "Category/Role") {
      const names = selected.map((selectedValue) => {
        const selectedItem = data?.find(
          (item) => item[valueField] === selectedValue,
        );
        return selectedItem ? selectedItem.name : selectedValue;
      });
      return names.join(", ");
    } else {
      return selected.join(", ");
    }
  };

  const safeInitialValue = toArray(initialValue);

  return (
    <div>
      <FormControl sx={{ width: 160 }}>
        <InputLabel id="demo-multiple-checkbox-label" sx={{ top: "-5px" }}>
          {name}
        </InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={selectOption}
          onChange={handleChange}
          input={<OutlinedInput label={name} />}
          renderValue={renderSelectedValue}
          MenuProps={MenuProps}
          sx={{
            borderRadius: "25px",
            position: "unset",
            "& .MuiSelect-select": { padding: "10px 16px" },
          }}
        >
          {data?.map((item) => (
            <MenuItem key={item[valueField]} value={item[valueField]}>
              <Checkbox
                checked={safeInitialValue.flat().includes(item[valueField])}
              />
              <ListItemText primary={item.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
